<template>
  <a-modal
      :title="`${actType}小组消耗目标`"
      centered
      :width="640"
      :mask-closable="false"
      :visible="showForm"
      :confirmLoading="loading"
      @cancel="close"
  >
    <a-form-model
      ref="form"
      :model="targetModel"
      :rules="rules"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
    >
      <a-form-model-item label="小组" prop="name">
        <a-input v-model="targetModel.name" disabled/>
      </a-form-model-item>
      
      <a-form-model-item label="月份" prop="month">
        <a-month-picker v-model="targetModel.month"  valueFormat="YYYY-MM" placeholder="请选择操作月份"/>
      </a-form-model-item>

      <a-form-model-item label="消耗目标" prop="name">
        <a-input v-model="targetModel.target" />
      </a-form-model-item>

    </a-form-model>
    <template slot="footer">
      <a-button @click="close" :disabled="loading">取消</a-button>
      <a-button type="primary" @click="submit" :disabled="loading">确定</a-button>
    </template>
  </a-modal>
</template>

<style lang="less" scoped>
@import 'Create';
</style>

<script>
import Create from './Create'

export default Create
</script>
